import { queryOptions } from '@tanstack/react-query'
import { vendorApi } from './api'
import { VendorFilter } from './models'
import { Pagination } from '@thinknimble/tn-models'

export const vendorQueries = {
  all: () => ['vendors'],
  retrieve: (id: string) => {
    return queryOptions({
      queryKey: [...vendorQueries.all(), id],
      queryFn: () => vendorApi.retrieve(id),
      enabled: Boolean(id),
    })
  },
  list: ({
    filters,
    pagination,
    paginationCallback,
  }: {
    filters?: Partial<VendorFilter>
    pagination?: Pagination
    paginationCallback?: (pagination: Pagination) => void
  }) => {
    return queryOptions({
      queryKey: [...vendorQueries.all(), { filters, pagination }],
      queryFn: async () => {
        const res = await vendorApi.list({
          filters,
          pagination,
        })
        const serverPagination = new Pagination({ ...res, totalCount: res.count })
        paginationCallback?.(serverPagination)
        return res
      },
      enabled: true,
    })
  },
}
